export default __webpack_public_path__ + "static/media/logoedu.aa8de190.png";